import { Component, OnInit } from "@angular/core";
import { SelectorItem } from "ng/src/app/shared/item-selectors/item-selector.model";
import { SystemParametersService } from "admin/src/app/system-parameters/system-parameters.service";
import { SystemParameter } from "admin/src/app/system-parameters/system-parameters.model";
import { finalize } from "rxjs/operators";

@Component({
	template: `
		<lb-paneled-viewer [items]="items" [(selected)]="selected" [loading]="loading">
			<ng-template pTemplate="content" let-src>
				<div style="max-width: 900px; margin: auto">
	                <div style="padding:62.5% 0 0 0;position:relative;">
		                <iframe [src]="('https://player.vimeo.com/video/' + src) | trustResource" style="position:absolute;top:0;left:0;width:100%;height:100%;" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen></iframe>
	                </div>
				</div>
			</ng-template>
			<ng-template pTemplate="empty">
				<div class="p-d-flex p-jc-center p-ai-center">
					{{items.length ? 'Select an item from the left' : ''}}
				</div>
			</ng-template>
		</lb-paneled-viewer>
	`
})
export class VideoTipsViewerComponent implements OnInit {
	items: SelectorItem<string>[] = [];
	selected?: any;
	loading = false;
	
	constructor(
		private sysParamService: SystemParametersService
	) {}
	
	ngOnInit(): void {
		this.refresh();
	}
	
	refresh() {
		this.loading = true;
		this.sysParamService.getNameLike(SystemParameter.parameterNames.TUTORIAL_VIDEOS).pipe(
			finalize(() => this.loading = false)
		).subscribe(params => {
			const param = params._embedded.systemParameters[0];
			if (!param) return;
			let value: SelectorItem<any>[] = [];
			try {
				value = JSON.parse(param.value);
			}
			catch (e) {
				value = [];
			}
			finally {
				this.items = Array.isArray(value) ? value : [];
			}
		})
	}
}